module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded'
  }, [_c('div', {
    staticStyle: {
      "height": "64px",
      "background": "#F66B3D"
    }
  }, [_c('img', {
    staticClass: "logo-img",
    staticStyle: {
      "width": "200px",
      "height": "auto",
      "margin-left": "15px"
    },
    attrs: {
      "src": require('@/assets/logo.svg')
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "250px",
      "background": "#fff",
      "text-align": "center",
      "overflow": "auto"
    }
  }, [(_vm.photo) ? _c('img', {
    staticClass: "home_img",
    attrs: {
      "id": "sz",
      "src": this.photo
    }
  }) : _c('img', {
    staticClass: "home_img",
    attrs: {
      "src": require("./img/login/head@2x.png")
    }
  }), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "home_span"
  }, [_vm._v(_vm._s(_vm.sysUserName))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "home_company"
  }, [_vm._v(_vm._s(_vm.company))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "home_point"
  }, [_vm._v(_vm._s(_vm.point))]), _c('span', {
    staticClass: "home_point1"
  }, [_vm._v(" 积分")])]), _vm._v(" "), _c('div', {
    staticClass: "cygn"
  }, [_c('span', {
    staticStyle: {
      "position": "relative",
      "left": "20px"
    }
  }, [_vm._v("常用功能")])]), _vm._v(" "), _c('el-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.currentPath,
      "unique-opened": "",
      "router": ""
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_c('el-menu-item', {
    staticClass: "icon_class",
    attrs: {
      "index": "management"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-kongzhizhongxin",
    staticStyle: {
      "position": "relative",
      "left": "5px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon_span",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("控制台")])]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "icon_class",
    attrs: {
      "index": "productList"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-wodechanpin",
    staticStyle: {
      "position": "relative",
      "left": "5px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon_span",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("我的产品")])]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "icon_class",
    attrs: {
      "index": "accountList"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-icon-",
    staticStyle: {
      "position": "relative",
      "left": "5px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon_span",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("我的账户")])]), _vm._v(" "), _c('el-menu-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.companymanageid || _vm.deptList.length > 0),
      expression: "companymanageid || deptList.length > 0"
    }],
    staticClass: "icon_class",
    attrs: {
      "index": "companyAll"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-shouquan",
    staticStyle: {
      "position": "relative",
      "left": "5px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon_span",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("企业管理")])]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "icon_class",
    attrs: {
      "index": "integral"
    }
  }, [_c('i', {
    staticClass: "el-icon-coin",
    staticStyle: {
      "position": "relative",
      "left": "0px",
      "font-weight": "bold"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon_span",
    staticStyle: {
      "left": "0px"
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("积分商城")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "top": "40px",
      "left": "20px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "color": "#F66B3D",
      "font-weight": "bold"
    }
  }, [_vm._v("退出登录")])])], 1)], 1), _vm._v(" "), (_vm.path != '/integral') ? _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)]) : _c('section', {
    staticClass: "section-class"
  }, [_c('router-view')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-028669ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 1111
// module chunks = 1